// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".footer_links span[data-v-291e900c] {\n  margin-right: 1rem;\n}\n", "",{"version":3,"sources":["webpack://./resources/js/components/theme/Footer.vue"],"names":[],"mappings":"AACA;EAEQ,kBAAkB;AAD1B","sourcesContent":["\n.footer_links {\n    span {\n        margin-right: 1rem;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
